import { useEffect, useState } from "react";
import { Loader2, PackageCheck, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Modal } from "@/components/Modal";

export function CloseOrderDialog({ order, onClose, onSaved }) {
  const [lines, setLines] = useState(null);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const valid = reason.trim().length >= 3;

  useEffect(() => {
    api.get(`/sales/${order.id}/delivery`).then((r) => setLines(r.data.data.lines)).catch((e) => { toast.error(apiError(e)); setLines([]); });
  }, [order.id]);

  const submit = async () => {
    if (!valid) { toast.error("Alasan tutup order wajib diisi (minimal 3 karakter)"); return; }
    setSaving(true);
    try {
      await api.post(`/sales/${order.id}/close`, { reason: reason.trim() });
      toast.success(`${order.so_number} ditutup — sisa tidak dikirim, order siap ditagih di Finance`);
      onSaved();
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Modal open onClose={onClose} title={`Tutup Order ${order.so_number}`} subtitle={order.outlet} testId="close-order-dialog"
      footer={<>
        <button className="rj-btn rj-btn-ghost" onClick={onClose} data-testid="close-order-cancel-btn">Batal</button>
        <button className="rj-btn rj-btn-green" onClick={submit} disabled={saving || !valid} data-testid="close-order-submit-btn">
          {saving ? <Loader2 size={16} className="spin" /> : <><PackageCheck size={16} /> Tutup Order</>}
        </button>
      </>}>
      <div className="void-warning"><AlertTriangle size={16} />
        <span>Sisa barang yang belum dikirim akan dibatalkan (tidak ada pengiriman lanjutan). Pengiriman di Odoo divalidasi sesuai qty terkirim, lalu order langsung masuk ke proses penagihan.</span></div>
      {lines === null ? <div className="rj-loading"><Loader2 className="spin" /> Memuat qty…</div> : (
        <table className="close-order-table" data-testid="close-order-lines">
          <thead><tr><th>Produk</th><th>Dipesan</th><th>Terkirim</th><th>Dibatalkan</th></tr></thead>
          <tbody>
            {lines.map((l) => (
              <tr key={l.product_odoo_id}>
                <td>{l.product_name}</td><td>{l.ordered_qty}</td><td><b>{l.already_shipped}</b></td>
                <td className={l.remaining_qty > 0 ? "cancel" : ""}>{l.remaining_qty}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <label className="rj-field"><span>Alasan tutup order <span className="void-required">*wajib</span></span>
        <textarea className="rj-input void-reason-input" rows={3} value={reason} autoFocus onChange={(e) => setReason(e.target.value)}
          placeholder="cth: Stok sisa kosong, customer setuju menerima sebagian" data-testid="close-order-reason-input" />
      </label>
    </Modal>
  );
}
